import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a duration in months into a human-readable string.
 * 9 -> "9 Months" · 12 -> "1 Year" · 18 -> "1 Year 6 Months" · 24 -> "2 Years"
 */
export function formatDuration(months: number | null | undefined): string {
  if (!months || months <= 0) return "—";
  if (months < 12) return `${months} ${months === 1 ? "Month" : "Months"}`;
  const years = Math.floor(months / 12);
  const rem = months % 12;
  const yearLabel = `${years} ${years === 1 ? "Year" : "Years"}`;
  if (rem === 0) return yearLabel;
  return `${yearLabel} ${rem} ${rem === 1 ? "Month" : "Months"}`;
}
